import { CHECKOUT_CART_DATA_KEY, CHECKOUT_CART_KEY, DXE_IS_MOBILE_APP } from '../constants/localStorageKeys';
import { routePatterns } from '../constants/routeTitles';
import { defaultSiteTitle } from '../constants/shop';

export const isMobileApp = localStorage.getItem(DXE_IS_MOBILE_APP);

export const removeOrderCheckoutLocalData = () => {
  localStorage.removeItem(CHECKOUT_CART_KEY);
  localStorage.removeItem(CHECKOUT_CART_DATA_KEY);
};

export const findRouteTitle = (pathname: string): string => {
  const route = routePatterns.find((r) =>
    typeof r.pattern === 'string' ? r.pattern === pathname : r.pattern.test(pathname),
  );
  return route ? `${route.title} | ${defaultSiteTitle}` : pathnameToTitle(pathname);
};

const pathnameToTitle = (pathname: string) => {
  const finalPathName = pathname
    // Remove leading and trailing slashes
    .replace(/^\/|\/$/g, '')
    // Remove .html extension
    .replace(/\.html/g, '')
    // Replace slashes, underscores, and hyphens with spaces
    .replace(/[/_-]/g, ' ')
    // Remove parameter placeholders
    .replace(/:\w+/g, '')
    // Replace multiple spaces with a single space
    .replace(/\s+/g, ' ')
    // Capitalize the first letter of each word
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .trim();
  return `${finalPathName} | ${defaultSiteTitle}`;
};
